/* Created by Hannah Green on 02/08/2021 for ES-133 */

import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import Select from "components/react-select";
import { useSnackbarContext } from "components/snackbar";
import RawForm from "components/form";
import { useTranslation } from 'react-i18next';
import { useMutation } from "react-query";
const { Input } = require("components/input");
const { Button } = require("components/button");

const Con = styled.div`
	display: flex;
	width: 400px;
	justify-content: space-between;
`;

const Form = styled(RawForm)`
	flex: 0 0 90%;
`;

export default function AddEditWhseForm(props) {
	const { t } = useTranslation();
	const tBase = "views.warehouse_management.components.addEditWhseForm";
	const tr = (key) => t(`${tBase}.${key}`);

	//Props variables
	const { formType, warehouseId } = props;
	const { showSnackbar } = useSnackbarContext();

	//State Variables
	const [warehouseDropdown, setWarehouseDropdown] = useState();
	const [vehicleDropdown, setVehicleDropdown] = useState();
	const [groupDropdown, setGroupDropdown] = useState();
	const [form, setForm] = useState({
		warehouse_name: "",
		group: { label: null, value: null },
		default_whse: { label: null, value: null },
		vehicle: { label: null, value: null },
		warehouse_id: warehouseId,
	});

	const mutation = useMutation(
		(form) => {
			axios.post(
				`${process.env.REACT_APP_SERVER_URL}/api/v1/eserv-business/warehouse/updateWarehouse`,
				form,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
		},
		{
			onSuccess: () => showSnackbar(tr("Completed!")),
		}
	);

	/* Database Functions */
	useEffect(() => {
		fetchData();
		if (formType === "edit") {
			fetchWarehouse();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const fetchData = async () => {
		try {
			const wDropdown = await axios.get(
				`${process.env.REACT_APP_SERVER_URL}/api/v1/eserv-business/warehouse?type=GETWHSEDROPDOWN`
			);
			setWarehouseDropdown(wDropdown.data);

			const vDropdown = await axios.get(
				`${process.env.REACT_APP_SERVER_URL}/api/v1/eserv-business/warehouse?type=GETVEHICLEDROPDOWN`
			);
			setVehicleDropdown(vDropdown.data);

			const gDropdown = await axios.get(
				`${process.env.REACT_APP_SERVER_URL}/api/v1/eserv-business/warehouse?type=GETGROUPDROPDOWN`
			);

			setGroupDropdown(gDropdown.data);
		} catch (e) {
			console.error(e);
		}
	};

	const fetchWarehouse = async () => {
		try {
			const warehouse = await axios.get(
				`${process.env.REACT_APP_SERVER_URL}/api/v1/eserv-business/warehouse?type=GETWAREHOUSE&warehouseId=${warehouseId}`
			);
			setForm(warehouse.data);
		} catch (e) {
			console.error(e);
		}
	};

	const handleChange = (e, { setFieldValue }) => {
		let { name, value } = e;
		switch (name) {
			case "group":
				const default_whse = groupDropdown.find((group) => {
					return group.value === value.value;
				});
				setFieldValue("default_whse", {
					label: default_whse.default_whse_name,
					value: default_whse.default_whse_id,
				});
				break;
			default:
				return;
		}
	};

	/* Submit Things */
	const handleSubmit = (e) => {
		try {
			let { ...form } = e;

			form.warehouse_id = warehouseId;

			const formData = new FormData();

			formData.append("form", JSON.stringify(form));

			mutation.mutate(formData);
			window.location.reload();
		} catch (e) {
			console.error(e);
		}
	};

	return (
		<Con>
			<Form
				initialValues={form}
				enableReinitialize={true}
				onChange={handleChange}
				onSubmit={handleSubmit}
			>
				<Input
					label={tr("Warehouse Name")}
					required
					name="warehouse_name"
					size="medium"
				/>

				<Select
					label={tr("Warehouse Group")}
					options={groupDropdown}
					name="group"
				/>

				<Select
					label={tr("Default Warehouse")}
					options={warehouseDropdown}
					name="default_whse"
				/>

				<Select
					label={tr("Vehicle")}
					options={vehicleDropdown}
					name="vehicle"
				/>

				<Button type="submit" primary>
					{tr("Submit")}
				</Button>
			</Form>
		</Con>
	);
}
